import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCollaborationPointerRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCollaborationPointerRight"><Path d="M8.8623 14.6631L9.21777 14.7822L9.33691 15.1377L11.4619 21.5127L10.0381 21.9873L8.03125 15.9678L2.0127 13.9619L2.4873 12.5381L8.8623 14.6631Z" fill="currentColor"/><Path d="M14.627 21.585L11.4131 12.5859L2.41504 9.37305L20.4111 3.58887L14.627 21.585Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCollaborationPointerRight;
